import axios from "axios";

export default class AuthService {
  static async getMessierId(): Promise<string | null> {
    try {
      const res = await axios.get(
        `${import.meta.env.VITE_API_URL}auth/messierId`,
        {
          withCredentials: true,
        }
      );

      if (res.data.data && res.data.data.messier_id) {
        return res.data.data.messier_id;
      }
      return null;
    } catch (error) {
      console.error("Error fetching messier Id:", error);
      return null;
    }
  }
}
